export default __webpack_public_path__ + "static/media/SchoolStreet.5df3444b.jpg";